import { ItemBadge } from "./ItemBadge";
import styles from './ItemBadgesContainer.module.scss';

export interface FilterItemBadgesContainerProps {
  badges: { name: string; onChange: () => void }[];
}

export const ItemBadgesContainer: React.FC<FilterItemBadgesContainerProps> = ({
  badges
}) => {
  if (badges.length === 0) return null;

  return (
    <div className={styles.filterItemBadgesContainer}>
      {badges.map((badge, index) => (
        <ItemBadge key={index} name={badge.name} onChange={badge.onChange} />
      ))}
    </div>
  );
}